import React from 'react';
import { FormPageFieldComponentProps } from 'types/formPage';
import {wrapComponent, extract} from "../../utils";
import {InputMask} from "primereact/inputmask";
import {InputText} from "primereact/inputtext";
import BaseNumber from "./BaseNumber";
import {changeOnBlur} from "./common";
import {InputTextarea} from "primereact/inputtextarea";

const BaseInput = ({ extraConfig, name, onChange: onChangeFinal, value:valueInit, onBlur:onBlurFinal, ...restProps }: FormPageFieldComponentProps & {type?:string}) => {
  const {mask, display_as} = extraConfig || {}
  const {value ='', onChange, onBlur} = changeOnBlur( name, valueInit, onChangeFinal, onBlurFinal, mask ? 'blur:val' : 'blur' )
  extraConfig = {...extraConfig}

  let comp = null
  if(display_as === 'number')comp = <BaseNumber {...{extraConfig: extraConfig.number_config, name, value: value || null, onChange, onBlur,  ...restProps}} />
  else if(['long_text','textarea','multiline','multiline_text','html','json','markdown'].includes(display_as)) comp = <InputTextarea  {...{name, value,onChange,onBlur}} {...extract( {autoResize: undefined, rows: 5, maxlength: undefined}, extraConfig, restProps)}   />
  else if(mask)comp = <InputMask  {...{name, value, onBlur}} {...extract( {mask:undefined, slotChar: undefined,autoClear:undefined, placeholder:undefined}, extraConfig, restProps)}/>
  else comp = <InputText {...{name, value, onChange, onBlur}} {...extract( {keyfilter: undefined, validateOnly: undefined, maxlength: undefined, minlength: undefined, pattern: undefined}, extraConfig, restProps)} />
  return wrapComponent( comp, extraConfig)

};

export default BaseInput;
